<script type="ts">
	import { page } from '$app/stores';
	import { redirect } from '@sveltejs/kit';
	import { domain } from '$lib/config/system';

	if ($page.status === 404) {
		throw redirect(301, '/not-found/');
	}
</script>

<section>
	<div class="root flex-column align-center">
		<section class="top-page">
			<h1>404</h1>

			<p>
				Oops
				<br />
				Your page not found. Sorry ;(
			</p>

			<a href="{domain}" type="button" class="action-button"> Back to home page</a>
		</section>
	</div>
</section>

<style lang="scss">
	@import '$styles/vars.scss';
	.root {
		.top-page {
			.action-button {
				color: $main-black;
			}
		}
	}
</style>
